// extracted by mini-css-extract-plugin
module.exports = {"forceColor":"_1FzGGrusCYvYM-XueTBsvV","textWithIcon":"_3RcLU2MDzPtl_RR3SB2g47","containerFilter":"_1XFUzAhca6UjQUXXl4C2bR","spaceLeft":"_8J5l1mYim_zM0CNKAr823"};